var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinLogoHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 50.5,
    fill: "#1C1C1D",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8173 55.9866C42.6413 55.9866 42.4656 55.9196 42.3312 55.7852C42.0628 55.5167 42.0628 55.0815 42.3312 54.8131L53.0748 44.0695C53.3429 43.801 53.7785 43.801 54.0469 44.0695C54.3154 44.338 54.3154 44.7732 54.0469 45.0416L43.3034 55.7852C43.1693 55.9193 42.9933 55.9866 42.8173 55.9866Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7561 60.9375C41.7083 60.9375 41.6598 60.9323 41.6113 60.922C41.2401 60.8423 41.0036 60.4769 41.0833 60.1056L42.1455 55.1546C42.2253 54.7833 42.5924 54.5475 42.9619 54.6266C43.3332 54.7063 43.5697 55.0717 43.4899 55.443L42.4277 60.394C42.3587 60.7168 42.0733 60.9375 41.7561 60.9375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.706 59.8755C46.53 59.8755 46.3543 59.8084 46.2199 59.674C45.9514 59.4056 45.9514 58.9704 46.2199 58.7019L56.9635 47.9587C57.2316 47.6902 57.6671 47.6902 57.9356 47.9587C58.2041 48.2271 58.2041 48.6623 57.9356 48.9308L47.1924 59.674C47.058 59.8084 46.882 59.8755 46.706 59.8755Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7544 60.9377C41.4372 60.9377 41.1522 60.717 41.0827 60.3942C41.0033 60.023 41.2395 59.6576 41.6107 59.5778L46.5618 58.5156C46.9334 58.4369 47.2988 58.6727 47.3782 59.0436C47.4576 59.4149 47.2214 59.7803 46.8502 59.86L41.8992 60.9222C41.8507 60.9329 41.8022 60.9377 41.7544 60.9377Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.505 51.0763C55.329 51.0763 55.153 51.0092 55.0189 50.8748L51.1301 46.986C50.8616 46.7175 50.8616 46.2823 51.1301 46.0139C51.3982 45.7454 51.8341 45.7454 52.1022 46.0139L55.991 49.9027C56.2595 50.1712 56.2595 50.6064 55.991 50.8748C55.857 51.0092 55.681 51.0763 55.505 51.0763Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.45 49.1322C57.274 49.1322 57.098 49.0651 56.9636 48.9307C56.6951 48.6623 56.6951 48.2271 56.9636 47.9583C57.3462 47.5757 57.5569 47.0576 57.5569 46.5001C57.5569 45.9425 57.3462 45.4245 56.9636 45.0419C56.5806 44.659 56.0626 44.4482 55.5051 44.4482C54.9475 44.4482 54.4295 44.659 54.0469 45.0419C53.7787 45.3104 53.3436 45.3107 53.0744 45.0419C52.8059 44.7734 52.8059 44.3382 53.0744 44.0694C53.7165 43.427 54.5797 43.0732 55.5051 43.0732C56.4301 43.0732 57.2936 43.427 57.9357 44.0694C58.5782 44.7116 58.9319 45.5747 58.9319 46.5001C58.9319 47.4255 58.5782 48.2886 57.9357 48.9307C57.802 49.0648 57.626 49.1322 57.45 49.1322Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinLogoHover);
export default __webpack_public_path__ + "static/media/coin-logo-hover.bcb4f579e3f942583b36fc7a21e6da02.svg";
export { ForwardRef as ReactComponent };